/* ================================================================
   Herb Terra Premium Interactions
   Sticky ATC, scroll reveals, micro-interactions.
   ================================================================ */

(function() {
  'use strict';

  /* ── Scroll Reveal ──────────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.htc-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('htc-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Sticky Add to Cart (Mobile) ────────────────────────────── */
  function initStickyATC() {
    var productForm = document.querySelector('.product-form');
    if (!productForm || window.innerWidth > 749) return;

    var title = document.querySelector('.product__title h1, .product__title .h1');
    var price = document.querySelector('.price-item--regular, .price-item--sale');
    if (!title || !price) return;

    var sticky = document.createElement('div');
    sticky.className = 'htc-sticky-atc';
    sticky.innerHTML =
      '<div class="htc-sticky-atc__inner">' +
        '<div class="htc-sticky-atc__info">' +
          '<div class="htc-sticky-atc__title">' + title.textContent.trim() + '</div>' +
          '<div class="htc-sticky-atc__price">' + price.textContent.trim() + '</div>' +
        '</div>' +
        '<button class="htc-sticky-atc__btn" type="button">Add to Cart</button>' +
      '</div>';
    document.body.appendChild(sticky);

    sticky.querySelector('.htc-sticky-atc__btn').addEventListener('click', function() {
      var submitBtn = productForm.querySelector('[type="submit"], .product-form__submit');
      if (submitBtn) submitBtn.click();
    });

    var formObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('htc-sticky-atc--visible');
        } else {
          sticky.classList.add('htc-sticky-atc--visible');
        }
      });
    }, { threshold: 0 });

    formObserver.observe(productForm);
  }

  /* ── Comparison Table Row Stagger ───────────────────────────── */
  function initCompareReveal() {
    var rows = document.querySelectorAll('.htc-compare__table tbody tr');
    if (!rows.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var rows = entry.target.querySelectorAll('tr');
          rows.forEach(function(row, i) {
            row.style.opacity = '0';
            row.style.transform = 'translateY(8px)';
            setTimeout(function() {
              row.style.transition = 'opacity 0.4s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.4s cubic-bezier(0.25,0.46,0.45,0.94)';
              row.style.opacity = '1';
              row.style.transform = 'translateY(0)';
            }, i * 60);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    var tbody = document.querySelector('.htc-compare__table tbody');
    if (tbody) observer.observe(tbody);
  }

  /* ── Init ────────────────────────────────────────────────────── */
  function init() {
    initReveal();
    initStickyATC();
    initCompareReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
